<template>
  <div class="max-h-[calc(100vh-10rem)] overflow-auto">
    <slot />
  </div>
</template>
